module.exports = __webpack_public_path__ + "media/images/icons/phone-cac808748e6a5e5964e43f04c18ac4fc.svg";